/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `EXW` - Ex Works
* `FCA` - Free Carrier
* `FAS` - Free Alongside Ship
* `FOB` - Free on Board
* `CFR` - Cost and Freight
* `CIF` - Cost, Insurance & Freight
* `CPT` - Carriage Paid To
* `CIP` - Carriage & Insurance Paid
* `DAP` - Delivered At Place
* `DDP` - Delivery Duty Paid
 */
export type Incoterms = typeof Incoterms[keyof typeof Incoterms];


export const Incoterms = {
  EXW: 'EXW',
  FCA: 'FCA',
  FAS: 'FAS',
  FOB: 'FOB',
  CFR: 'CFR',
  CIF: 'CIF',
  CPT: 'CPT',
  CIP: 'CIP',
  DAP: 'DAP',
  DDP: 'DDP',
} as const;
